export default function dateDiff(date){
  const dateY = date.getFullYear()
  const dateM = date.getMonth()
  const dateD = date.getDate()
  const newDate = new Date(dateY, dateM, dateD)

  const now = new Date()
  const nowY = now.getFullYear()
  const nowM = now.getMonth()
  const nowD = now.getDate()
  const nowDate = new Date(nowY, nowM, nowD)

  const day = parseInt(Math.abs(nowDate - newDate) / 1000 / 60 / 60 /24) //把相差的毫秒数转换为天数
  if (day === 0) {
    return '今天'
  }
  return day + '天前'
}



// WEBPACK FOOTER //
// ./src/utils/dateDiff.js